import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

import Accordion from '../Accordion'
import BlockTitle from '../BlockTitle'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(144)};
  }
`

export const _BlockTitle = styled(BlockTitle)`
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`
export const Accordions = styled(motion.dl)`
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc((100% - ${pxToRem(32)} * 2) * 2 / 3);
    margin-inline: auto ${pxToRem(32)};
  }
`
export const _Accordion = styled(Accordion)`
  border-block-start: 1px solid rgba(0, 0, 0, 0.1);
  transition: border-color 0.3s ease-out;
  &:last-child {
    border-block-end: 1px solid rgba(0, 0, 0, 0.1);
  }
  &:hover {
    border-color: rgba(0, 0, 0, 0.5);
  }
  &:hover + & {
    border-block-start-color: rgba(0, 0, 0, 0.5);
  }
  &:focus-within {
    border-color: rgba(0, 0, 0, 0.5);
  }
  &:focus-within + & {
    border-block-start-color: rgba(0, 0, 0, 0.5);
  }
  &[data-open='true'] {
    border-color: rgba(0, 0, 0, 0.5);
  }
  &[data-open='true'] + & {
    border-block-start-color: rgba(0, 0, 0, 0.5);
  }
`
